<table>
    <thead>
        <tr>
            <th class="subtable icon"></th>
            <th class="subtable icon"></th>
            <th class="subtable id sortable" (click)="toOrderBy('1')" [appSort]="listaDesignacionesFinca" data-order="desc" data-name="id">
              {{'mantenimientoCultivos.tabs.designaciones.table.id' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('1')"></i>
              </div>
            </th>
            <th class="subtable string sortable" (click)="toOrderBy('2')" [appSort]="listaDesignacionesFinca" data-order="desc" data-name="desDenominacion">
              {{'mantenimientoCultivos.tabs.designaciones.table.denominacion' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('2')"></i>
              </div>
            </th>
            <th class="subtable string sortable" (click)="toOrderBy('3')" [appSort]="listaDesignacionesFinca" data-order="desc" data-name="desMarca">
              {{'mantenimientoCultivos.tabs.designaciones.table.marca' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('3')"></i>
              </div>
            </th>
            <th class="subtable string sortable" (click)="toOrderBy('4')" [appSort]="listaDesignacionesFinca" data-order="desc" data-name="fecha">
              {{'mantenimientoCultivos.tabs.designaciones.table.fecha' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('4')"></i>
              </div>
            </th>
            <th class="subtable string sortable" (click)="toOrderBy('5')" [appSort]="listaDesignacionesFinca" data-order="desc" data-name="desEtiquetador">
              {{'mantenimientoCultivos.tabs.designaciones.table.etiquetador' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('5')"></i>
              </div>
            </th>
            <th class="subtable string sortable" (click)="toOrderBy('6')" [appSort]="listaDesignacionesFinca" data-order="desc" data-name="cantidad">
              {{'mantenimientoCultivos.tabs.designaciones.table.designado' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('6')"></i>
              </div>
            </th>
            <!-- <th class="action">
                <i class="fas fa-plus"></i>
            </th> -->
        </tr>
    </thead>
    <tbody *ngFor="let designacionFinca of listaDesignacionesFinca; let i=index;">
        <tr (click)="showMoreInfo(i)" [ngClass]="{'dropdownInfo': blockchainInfo === i}" [ngStyle]="{'cursor': ((designacionFinca && designacionFinca.designacionVechain?.existeRegBlockchain) && this.claims.includes('D_EC_InfoBlockchainVisible')) ? 'pointer' : ((designacionFinca && designacionFinca.designacionVechain?.existeRegBlockchain) && this.role === 'Administrador' ? 'pointer' : 'auto')}">
            <td>
              <i
                *ngIf="((designacionFinca && designacionFinca.designacionVechain?.existeRegBlockchain) && this.claims.includes('D_EC_InfoBlockchainVisible')) || ((designacionFinca && designacionFinca.designacionVechain?.existeRegBlockchain) && this.role === 'Administrador')"
                [ngClass]="blockchainInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm' "
                title="{{blockchainInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
            </td>
            <td>
              <a *ngIf="((designacionFinca && designacionFinca.designacionVechain?.existeRegBlockchain) && this.claims.includes('D_EC_InfoBlockchainVisible')) || ((designacionFinca && designacionFinca.designacionVechain?.existeRegBlockchain) && this.role === 'Administrador')" href="{{designacionFinca.designacionVechain?.txIdExplore}}" target="_blank">
                <i class="fas fa-circle-nodes" title="{{'global.blockchain.verBlockchain' | translate}}" style="cursor: pointer;"></i>
              </a>
            </td>
            <td class="id">{{designacionFinca.id}}</td>
            <td class="string">{{designacionFinca.desDenominacion}}</td>
            <td class="string">{{designacionFinca.desMarca}}</td>
            <td class="string">{{designacionFinca.fecha | date: 'shortDate' : undefined : defaultLanguage}}</td>
            <td class="string">{{designacionFinca.desEtiquetador}}</td>
            <td class="string">{{designacionFinca.cantidad}}</td>
            <!-- <td class="actions">
                <i class="fas fa-pencil-alt"></i>
                <i class="far fa-trash-alt"></i>
            </td> -->
        </tr>
        <!-- Campos blockchain -->
        <tr *ngIf="(blockchainInfo === i && (designacionFinca && designacionFinca.designacionVechain?.existeRegBlockchain) && this.claims.includes('D_EC_InfoBlockchainVisible')) || (blockchainInfo === i && (designacionFinca && designacionFinca.designacionVechain?.existeRegBlockchain) && this.role === 'Administrador')">
          <td colspan="8">
            <div class="detail">
              <div class="title">{{'global.blockchain.informacion.titulo' | translate}}</div>
              <div class="block-inline">
                <label>{{'global.blockchain.informacion.blockchain' | translate}}</label>
                <p>{{designacionFinca.designacionVechain?.blockchain}}</p>
              </div>
              <div class="block-inline gap">
                <label>{{'global.blockchain.informacion.fechaRegistro' | translate}}</label>
                <p>{{designacionFinca.designacionVechain?.fechaRegistro | date: 'dd/MM/yyyy HH:mm:ss'}}</p>
              </div>
              <div class="block-inline gap nowrap">
                <label>{{'global.blockchain.informacion.input' | translate}}</label>
                <p>{{designacionFinca.designacionVechain?.textoHash}}</p>
              </div>
              <div class="block-inline">
                <label></label>
                <p></p>
              </div>
              <div class="block-inline gap nowrap">
                <label>{{'global.blockchain.informacion.idCripto' | translate}}</label>
                <p>{{designacionFinca.designacionVechain?.txId}}</p>
              </div>
              <div class="block-inline">
                <label></label>
                <p></p>
              </div>
              <div class="block-inline">
                <label></label>
                <p></p>
              </div>
              <div class="block-inline">
                <label></label>
                <p></p>
              </div>
              <div class="block-inline gap nowrap">
                <label>{{'global.blockchain.informacion.hash' | translate}}</label>
                <p>{{designacionFinca.designacionVechain?.hash}}</p>
              </div>
              <div class="block-inline">
                <label></label>
                <p></p>
              </div>
              <div class="block-inline">
                <label></label>
                <p></p>
              </div>
              <div class="block-inline">
                <label></label>
                <p></p>
              </div>
            </div>
          </td>
        </tr>
    </tbody>
    <tfoot *ngIf="!listaDesignacionesFinca || (listaDesignacionesFinca && listaDesignacionesFinca.length < 1)">
        <tr>
          <td colspan="11">
            {{'global.noContent' | translate}}
          </td>
        </tr>
    </tfoot>
</table>

